export const getBasePath = (path: string): string => {
  return (path.split('/f/')[0] || '').split('?')[0] || '';
};
